<template>
  <div>
    <Container class="min-h-[70vh]">
      <div class="max-w-prose">
        <ContentHeader
          :title="$texts('login', 'Anmelden')"
          :lead="
            $texts(
              'loginText',
              'Melden Sie sich mit Ihrer 7-stellige Mitglieder- bzw. FPH-Nummer oder E-Mail-Adresse an.',
            )
          "
        />
      </div>
      <LoginForm :target-role="roleContext" />
    </Container>
  </div>
</template>

<script lang="ts" setup>
const { $texts } = useNuxtApp()
await initFormKit()
const route = useRoute()

const roleContext = computed(() => {
  return route.query.role as string
})

definePageMeta({
  name: 'login',
  middleware: ['anonymous-only'],
  pageTransition: {
    name: 'page-fade',
  },
})

useHead({
  title: $texts('login', 'Anmelden'),
})

setBreadcrumbLinks()
useRouteCache((c) => c.setCacheable().setMaxAge(600))
await renderPageDependencies()
</script>

<script lang="ts">
export default {
  name: 'PagePharmasuisseUserLogin',
}
</script>
